import './styles/global.css';
import { App } from './ui/App';

const app = document.querySelector<HTMLDivElement>('#app');
const canvas = document.querySelector<HTMLCanvasElement>('#structure-canvas');

if (!app || !canvas) throw new Error('Built by Keemo: application mount points are missing.');

const experience = new App(app, canvas);
void experience.init().catch((error: unknown) => {
  console.error('Built by Keemo failed to initialize the 3D experience.', error);
  document.documentElement.classList.add('renderer-failed');
  const loader = document.querySelector<HTMLElement>('.loader');
  loader?.classList.add('is-complete');
});
